export const mapStyles = [{
  'stylers': [{ 'visibility': 'off' }]
},
{
  'featureType': 'landscape',
  'elementType': 'geometry',
  'stylers': [{ 'visibility': 'on' }, { 'color': '#efefef' }]
},
{
  'featureType': 'water',
  'elementType': 'geometry',
  'stylers': [{ 'visibility': 'on' }, { 'color': '#bcd2e8' }] 
}];
